<script>
  import TabelaDetalheLinha from './TabelaDetalheLinha.vue';
  
  export default {
    props: {
      dados: {
        type: Array,
        required: true,
      }
    },
    components: {TabelaDetalheLinha},
    data() {
      return {
        indiceAperto: null, 
      }
    },
    methods: {
      mostrarEsconder(i) {
        if (this.indiceAperto === i)
          this.indiceAperto = null;
        else
          this.indiceAperto = i;
      }
    },
  }
</script>

<template>
  <table class="table table-bordered table-hover">
    <thead>
    <tr>
      <th>Curso</th>
      <th>Turma</th>
    </tr>
    </thead>
    <tabela-detalhe-linha 
      v-for="(item, i) in dados" 
      @click="mostrarEsconder(i)" 
      :open="indiceAperto === i" 
      :dados="item">
    </tabela-detalhe-linha>
  </table>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/curso/componentes/TabelaDetalhe.vue